// extracted by mini-css-extract-plugin
export default {"container":"Ecllpsys_container__Hb6I8","leftSection":"Ecllpsys_leftSection__TNm3C","RightSection":"Ecllpsys_RightSection__yQkRE"};